import { tailwindTheme as o } from "../tailwind/index.js";
const c = {
  token: {
    fontSize: 14,
    fontFamily: o.fontFamily.sans.join(","),
    // Primary
    colorPrimary: o.colors.primary,
    colorPrimaryHover: o.colors.green[700],
    colorPrimaryActive: o.colors.green[800],
    colorPrimaryBg: o.colors.green[50],
    colorPrimaryBgHover: o.colors.green[200],
    colorPrimaryBorder: o.colors.primary,
    colorPrimaryBorderHover: o.colors.green[700],
    colorPrimaryText: o.colors.primary,
    colorPrimaryTextHover: o.colors.green[700],
    colorPrimaryTextActive: o.colors.green[800],
    // Success
    colorSuccess: o.colors.success,
    colorSuccessHover: o.colors.green[700],
    colorSuccessActive: o.colors.green[800],
    colorSuccessBg: o.colors.green[50],
    colorSuccessBgHover: o.colors.green[200],
    colorSuccessBorder: o.colors.success,
    colorSuccessBorderHover: o.colors.green[700],
    colorSuccessText: o.colors.success,
    colorSuccessTextHover: o.colors.green[700],
    colorSuccessTextActive: o.colors.green[800],
    // Secondary
    colorBgSolid: o.colors.secondary,
    colorBgSolidHover: o.colors.gray[600],
    colorBgSolidActive: o.colors.gray[700],
    // Info
    colorInfo: o.colors.info,
    colorInfoHover: o.colors.blue[600],
    colorInfoActive: o.colors.blue[700],
    colorInfoBg: o.colors.blue[50],
    colorInfoBgHover: o.colors.blue[200],
    colorInfoBorder: o.colors.info,
    colorInfoBorderHover: o.colors.blue[600],
    colorInfoText: o.colors.info,
    colorInfoTextHover: o.colors.blue[600],
    colorInfoTextActive: o.colors.blue[700],
    // Warning
    colorWarning: o.colors.warning,
    colorWarningHover: o.colors.yellow[600],
    colorWarningActive: o.colors.yellow[700],
    colorWarningBg: o.colors.yellow[50],
    colorWarningBgHover: o.colors.yellow[200],
    colorWarningBorder: o.colors.warning,
    colorWarningBorderHover: o.colors.yellow[600],
    colorWarningText: o.colors.warning,
    colorWarningTextHover: o.colors.yellow[600],
    colorWarningTextActive: o.colors.yellow[700],
    // Error
    colorError: o.colors.error,
    colorErrorHover: o.colors.red[700],
    colorErrorActive: o.colors.red[800],
    colorErrorBg: o.colors.red[50],
    colorErrorBgHover: o.colors.red[200],
    colorErrorBorder: o.colors.error,
    colorErrorBorderHover: o.colors.red[700],
    colorErrorText: o.colors.error,
    colorErrorTextHover: o.colors.red[700],
    colorErrorTextActive: o.colors.red[800]
  },
  components: {
    // Button: {
    //   // defaultHoverColor: 'unset',
    //   // defaultHoverBorderColor: tw.colors.gray[600],
    //   // defaultActiveColor: 'unset',
    //   // defaultActiveBorderColor: tw.colors.gray[700],
    // },
    Segmented: {
      itemColor: o.colors.black,
      itemHoverBg: o.colors.gray[200],
      itemSelectedBg: o.colors.primary,
      itemSelectedColor: o.colors.white
    },
    Table: {
      cellPaddingInlineMD: 12,
      bodySortBg: "initial",
      headerSortActiveBg: "#fafafa"
    }
  }
};
export {
  c as antdTheme
};
